<template>
    <div>
        <div class="cards" v-for="(item,index) in exportInvoiceList" :key="index">
            <van-row type="flex" justify="space-between" class="filing-material-card-title">
                <span class="title">出口发票 - {{ index + 1 }}</span>
                <i class="delete-card" @click="deleteItem(index)"></i>
            </van-row>

            <van-row>
                <span class="label">发票号</span>
                <span class="cont">{{ item.num }}</span>
            </van-row>

            <van-row>
                <span class="label">发票日期</span>
                <span class="cont">{{ item.time }}</span>
            </van-row>

            <van-row>
                <span class="label">发票金额</span>
                <span class="cont">{{ item.amount }}</span>
            </van-row>

            <van-row>
                <span class="label">价格条款</span>
                <span class="cont">{{ item.provision }}</span>
            </van-row>

        </div>
    </div>
</template>

<script>
    import {eventBus, noticeManager} from "@zhoujianhui/vip-core"

    export default {
        name: "exportInvoiceCard",
        data() {
            return {
                exportInvoiceList: []
            }
        },
        created(){
            eventBus.$on("addExportInvoice",(data)=>{
                this.exportInvoiceList.push(data);
            })

        },
        methods: {
            deleteItem(index){
                this.exportInvoiceList.splice(index,1);
            },
            async validate() {
                if(this.exportInvoiceList.length <= 0 ) {
                    noticeManager.showMessage("出口发票不能为空，请添加出口发票", "error");
                    return new Promise(resolve => resolve(false))
                }else{
                    return new Promise(resolve => resolve(true))
                }
            },
            getExportInvoices() {
                return this.exportInvoiceList;
            }
        }
    }
</script>


